<!-- =============
Màn hình hiển thị bộ đếm thời gian
Author: hvanh - 05.2.2024
===============-->
<template>
	<div class="content-time">
		<div
			class="mi-new-v2 mi-16 mi-icon-v2-help-blue ms-mgr-4px"
			v-if="!iconRight"
			@click="viewHelp"
		></div>
		<div class="timer-title" v-if="!noTitle">
			{{ $t('i18nCommon.TimerSyncConnectTaxixion') }}
		</div>
		<div
			class="countdown-time"
			v-tooltip="isShowTooltip ? $t('i18nCommon.TimerSyncConnectTaxixion') : ''"
		>
			<div class="text-timer">
				{{ timeLeft.hours >= 10 ? timeLeft.hours : '0' + timeLeft.hours }}
			</div>
			<span class="dot-timer">:</span>
			<div class="text-timer">
				{{ timeLeft.minutes >= 10 ? timeLeft.minutes : '0' + timeLeft.minutes }}
			</div>
			<span class="dot-timer">:</span>
			<div class="text-timer">
				{{ timeLeft.seconds >= 10 ? timeLeft.seconds : '0' + timeLeft.seconds }}
			</div>
			<div
				class="ms-mgl-8px"
				:class="[iconRightCustom ? iconRightCustom : 'mi mi-16 mi-help-blue']"
				v-if="iconRight"
				@click="viewHelp"
			></div>
		</div>
	</div>
</template>
  <script>
import DateUtils from '@/utils/dateUtil.js';
export default {
	name: 'msTimer',
	props: {
		/**
		 * Danh sách khoảng thời gian
		 */
		listTime: {
			typeof: Array,
			default: [],
		},
		iconRight: {
			typeof: Boolean,
			default: false,
		},
		noTitle: {
			typeof: Boolean,
			default: false,
		},
		iconRightCustom: {
			typeof: String,
			default: '',
		},
		isShowTooltip: {
			typeof: Boolean,
			default: true,
		},
	},
	mounted() {},
	data() {
		return {
			timeLeft: {
				hours: 0,
				minutes: 0,
				seconds: 0,
			},
			listTimeCurrent: [],
			runTime: null,
		};
	},
	computed: {},
	created() {
		// hvanh - 19.2.2024 - fixbug: vào màn hình hiển thị bộ đếm luôn chứ không chờ 1s sau mới gọi
		this.caculatorTimeLeft();
		this.runTime = setInterval(() => {
			this.caculatorTimeLeft();
		}, 1000);
	},
	methods: {
		/**
		 * Hàm tính toán thời gian hiện tại tới khoảng thời gian trong danh sách
		 */
		caculatorTimeLeft() {
			const me = this;
			me.listTimeCurrent = me.listTime;
			// lấy ra thời gian hiện tại
			const dateNow = new Date();
			// Lấy ra khung giờ gần nhất với thời gian hiện tại
			let nextHourInfos = me.listTimeCurrent.filter(
				(x) =>
					x &&
					((x.hours >= dateNow.getHours() &&
						x.minutes > dateNow.getMinutes()) ||
						(x.hours > dateNow.getHours() && x.minutes == dateNow.getMinutes()))
			);

			let nextDate = dateNow;
			let hourInfo = me.listTimeCurrent[0];

			//Qua mốc giờ cuối cùng khi mảng k có dữ liệu
			if (!nextHourInfos || nextHourInfos.length <= 0) {
				nextDate.addDays(1);
			} else {
				hourInfo = nextHourInfos[0];
			}

			nextDate = dateNow.setSeconds(0);
			nextDate = dateNow.setMinutes(hourInfo.minutes);
			nextDate = dateNow.setHours(hourInfo.hours);
			//Khoảng cách thời gian giữa 2 khoảng thời gian tính bằng giây
			let seconds = DateUtils.secondsDiff(nextDate, Date.now());
			me.timeLeft.hours = parseInt(seconds / 3600);
			me.timeLeft.minutes = parseInt((seconds % 3600) / 60);
			me.timeLeft.seconds = parseInt(seconds % 60);
		},

		viewHelp() {
			const me = this;
			me.$ms.commonFunc.helpLink(window.__env.authConfig.linkHelpSyncInvMiss);
		},
	},
	beforeDestroy() {
		const me = this;
		if (me.runTime) {
			clearInterval(me.runTime);
		}
	},
};
</script>

<style lang="scss" scoped>
.content-time {
	display: flex;
	font-size: 13px;
	align-items: center;
	margin-right: 6px;
}
.text-timer {
	font-size: 13px;
	display: flex;
	color: var(--ms-color-neutral-1000);
	align-items: center;
	justify-content: center;
	height: 24px;
	border-radius: 4px;
	width: 18px;
}
.dot-timer {
	font-weight: 700;
	color: var(--ms-color-neutral-1000);
}
.timer-title {
	margin-right: 8px;
	font-size: 13px;
	color: var(--ms-color-neutral-1000);
}
.countdown-time {
	display: flex;
	align-items: center;
	border-radius: 6px;
	border: 1px solid var(--ms-color-border);
	padding: 2px 4px 2px 8px;
	height: 32px;
}
</style>

